import get from 'lodash/get';
import { sameVulnId } from 'Common/Functions/vulnerabilityId';

const parseId = (id) => {
  if (id === '_id') return 'id';
  if (id === 'workspace__name') return 'workspace_name';
  if (id === 'target') return 'asset';
  if (id === 'type') return 'web';
  return id;
};

// Saves field width when user resize column
export const handleResizedChange = (changes, fields, pSetFieldWidth) => {
  const lastChange = changes[changes.length - 1];
  if (!lastChange) return false;

  const id = parseId(lastChange.id);
  const field = get(fields, id, null);
  const newValue = get(lastChange, 'value', 0);
  const defaultMin = get(field, 'defaultMin', 0);
  const roundedValue = Math.abs(Math.round(newValue));

  if (!field) return false;
  if (roundedValue >= defaultMin) pSetFieldWidth(id, roundedValue);
  else pSetFieldWidth(id, defaultMin);

  return false;
};

export const findSelectedVuln = (rowInfo, vulnsSelected) => (rowInfo?.original ? vulnsSelected.find((vuln) => sameVulnId(vuln, rowInfo.original)) : null);

export const getTrProps = (rowInfo, vulnsSelected, selectVuln, unSelectAll, showContextMenu, isFetching) => {
  const selected = findSelectedVuln(rowInfo, vulnsSelected);
  if (rowInfo && rowInfo.row) {
    return {
      onContextMenu: (e) => {
        e.preventDefault();
        showContextMenu(true, e.pageX, e.pageY);
        if (!selected && !isFetching) {
          unSelectAll();
          selectVuln(rowInfo.original);
        }
      },
      className: selected ? 'selected' : 'test-table-selector'
    };
  }
  return {};
};

// Set width and styles for table header
export const getThProps = (column, fields, currentBreakpoint, showVulnDetail, showContextMenu, isDisplayingContextMenu) => {
  const extendFieldName = (showVulnDetail && currentBreakpoint === 'second');
  const id = parseId(column.id);
  const maxWidth = fields[id] ? fields[id].maxWidth : 0;
  const defaultMin = fields[id]?.defaultMin || 0;
  const response = { minWidth: defaultMin, maxWidth };
  const maxWidthClass = fields.name ? `max-wd-${fields.name.maxWidth}` : '';

  if (column.id === 'name') response.maxWidth = extendFieldName ? '' : maxWidthClass;

  return {
    style: defaultMin ? response : {},
    className: column.id === 'expander' ? `display-none ${extendFieldName ? '' : maxWidthClass}` : `${extendFieldName ? '' : maxWidthClass}`,
    onContextMenu: (e) => {
      e.preventDefault();
      if (isDisplayingContextMenu) showContextMenu(false);
    }
  };
};

const DEFAULT_WIDTH = 120;
const DEFAULT_MIN = 60;
const DEFAULT_MAX = 1000;

export const normalizeColumns = (cols) => {
  return cols.map(col => {
    const min = Number.isFinite(col.minWidth) ? col.minWidth : DEFAULT_MIN;
    const max = Number.isFinite(col.maxWidth) ? col.maxWidth : DEFAULT_MAX;

    // Si no tiene width explícito, lo calculamos
    let width;

    if (Number.isFinite(col.width)) {
      width = col.width;
    } else if (Number.isFinite(col.minWidth)) {
      width = col.minWidth;
    } else if (Number.isFinite(col.maxWidth)) {
      width = col.maxWidth;
    } else {
      width = DEFAULT_WIDTH;
    }

    // Clamp por seguridad
    if (width < min) width = min;
    if (width > max) width = max;

    return {
      ...col,
      width,
      minWidth: min,
      maxWidth: max
    };
  });
};
